import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const PageTitle = ({ title }) => {
    const location = useLocation();

    useEffect(() => {
        document.title = title;
    }, [location, title]);

    return null;
};

PageTitle.propTypes = {
    title: PropTypes.string.isRequired,
};

export default PageTitle;
